module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeSpoon@2x.c51074ce.png";